import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { makeStyles, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { capitalize } from '@material-ui/core';

const styles = () => ({
  root: {},
  radioRoot: {}, // Does not exist in Material UI FormControlLabel
});

const MUI_COLORS = [
  'primary',
  'secondary',
  'default',
];

export const COLORS = [
  ...MUI_COLORS,
  'white',
];

const getColorProp = (color) => {
  if (COLORS.includes(color)) {
    return color;
  }
  return 'default';
};

const getRootColor = (color) => {
  return {
    color,
  };
};

const getRadioColor = (color) => {
  return {
    color,
  };
};

const useCustomStyles = makeStyles(theme => ({
  rootColorPrimary: {},
  rootColorSecondary: {},
  rootColorWhite: getRootColor(theme.palette.common.white),
  radioColorPrimary: {},
  radioColorSecondary: {},
  radioColorWhite: getRadioColor(theme.palette.common.white),
}));

const RadioOption = ({
  className,
  classes,
  value,
  label,
  color,
  disabled,
}) => {
  const {
    radioRoot: radioRootClass,
    root: rootClass,
    ...restClasses
  } = classes;
  const customClasses = useCustomStyles();
  return (
    <FormControlLabel
      classes={{
        root: classNames(classes.root, className, customClasses[`rootColor${capitalize(color)}`]),
        ...restClasses,
      }}
      disabled={disabled}
      value={value}
      control={
        <Radio
          color={getColorProp(color)}
          classes={{
            root: classNames(radioRootClass, customClasses[`radioColor${capitalize(color)}`]),
          }}
        />
      }
      label={label}
      test={`picklist-radio-group-option-${value}`}
    />
  );
};

RadioOption.defaultProps = {
  className: '',
  disabled: false,
};

RadioOption.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(COLORS).isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(RadioOption);
